module.exports = __webpack_public_path__ + "static/media/DIN-Condensed-Bold.4675a4b4.woff";